import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 41">
      <g fill="none" fill-rule="evenodd">
        <path
          d="M28.915 24.466c-.391 0-.78-.099-1.125-.286l-12.808-6.936a2.404 2.404 0 0 1-.97-3.237 2.38 2.38 0 0 1 3.23-.978l12.808 6.936a2.404 2.404 0 0 1 .97 3.237 2.38 2.38 0 0 1-2.105 1.264h0Z"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M37.71 2.573a4.177 4.177 0 0 0-2.986-1.246 4.177 4.177 0 0 0-2.986 1.246c-.439.443-.77.98-.976 1.567a3.575 3.575 0 0 0-3.028 1.032L25.3 7.695l-2.19-1.186a2.38 2.38 0 0 0-3.23.978 2.404 2.404 0 0 0 .97 3.238l1.003.542-2.7 2.798-1.912-1.035a2.38 2.38 0 0 0-3.23.978 2.404 2.404 0 0 0 .97 3.237l.726.393-2.747 2.846-2.104-1.14a2.38 2.38 0 0 0-3.23.978 2.404 2.404 0 0 0 .97 3.237l.918.497-1.048 1.086a3.683 3.683 0 0 0-.342 4.757l-2.096 2.114a4.204 4.204 0 0 0-3.883 1.146 4.271 4.271 0 0 0 0 5.998 4.177 4.177 0 0 0 2.986 1.247 4.176 4.176 0 0 0 2.986-1.247 4.225 4.225 0 0 0 1.09-4.068l2.028-2.045c.628.48 1.393.74 2.199.74a3.6 3.6 0 0 0 2.573-1.07l3.21-3.402 2.187 1.184a2.38 2.38 0 0 0 3.23-.978 2.404 2.404 0 0 0-.97-3.237l-1.05-.569 2.706-2.868 2.469 1.337a2.38 2.38 0 0 0 3.23-.978 2.404 2.404 0 0 0-.97-3.237l-1.332-.721 2.66-2.82 2.282 1.236a2.38 2.38 0 0 0 3.23-.978 2.404 2.404 0 0 0-.97-3.237l-1.145-.62.865-.917a.993.993 0 0 0 .061-.071 3.93 3.93 0 0 0 .593-1.163c.128-.419.16-.83.1-1.212.492-.209.939-.511 1.316-.89a4.271 4.271 0 0 0 0-5.999h0Z"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.132 41.543a1.36 1.36 0 0 1-.972-.406 1.395 1.395 0 0 1 0-1.96c.256-.26.606-.406.972-.405.367 0 .712.144.971.406.536.54.536 1.419 0 1.959a1.36 1.36 0 0 1-.971.406Zm29.592-30.585c-.367 0-.712-.144-.972-.406a1.396 1.396 0 0 1 0-1.959 1.36 1.36 0 0 1 .972-.406c.367 0 .712.144.971.406.536.54.536 1.419 0 1.96-.256.26-.606.406-.971.405Z"
          fill="#000"
          mask="url(#mask-2)"
          transform="translate(-5 -4)"
        />
        <path
          d="M27.53 34.78c-.391 0-.78-.098-1.126-.285l-12.808-6.936a2.404 2.404 0 0 1-.97-3.238 2.38 2.38 0 0 1 3.23-.977l12.809 6.936a2.404 2.404 0 0 1 .97 3.237 2.38 2.38 0 0 1-2.105 1.264Zm12.256-12.834c-.392 0-.781-.1-1.126-.286l-12.808-6.936a2.404 2.404 0 0 1-.97-3.238 2.38 2.38 0 0 1 3.23-.977l12.808 6.936a2.404 2.404 0 0 1 .97 3.237 2.38 2.38 0 0 1-2.104 1.264Z"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          mask="url(#mask-2)"
          transform="translate(-5 -4)"
        />
      </g>
    </svg>
  );
};

export default Icon;
